module.exports = __webpack_public_path__ + "cloud-optimization.2_pfYFL9.svg";